import React from 'react'
import { LangSteps34 } from '../../../constant/languange'
import Content from '../Content'

const Third4 = (props) => {
  const data = {
    title: '',
    steps: [LangSteps34],
    button: 'Mulai Tambah Karyawan',
    nextStep: 4,
    skipTo: '/personnel/work/time',
    isDone: props.stats.personnels_count
  }

  return <Content {...props} data={data} />
}

export default Third4
